import { useStore } from 'vuex'

export default {
    name: "FundraisingAsideVue",
    props: {
        isAuthenticated: {
            type: Boolean,
            required: false
        },
        creatorProfile: {
            type: Object,
            required: false
        },
        ownsPersonalFundraising: {
            type: Boolean,
            required: false
        },
        detailItems: {
            type: Array,
            required: false
        },
        loginLogoutButton: {
            type: Object,
            required: false
        },
        editFundraising: {
            type: Object,
            required: false
        },
        qrImgUrlBase: {
            type: String,
            required: false
        },
        qrPrintPageLink: {
            type: String,
            required: false
        },
        qrPrintPageLinkTarget: {
            type: String,
            required: false
        },
        mobilePayCommentCode: {
            type: String,
            required: false
        },
        mobilePayNumberCode: {
            type: String,
            required: false
        },
        personalFundraisingGuid: {
            type: String,
            required: true
        },
        useQrCode: {
            type: Boolean,
            required: true
        },
        addressDetails: {
            type: Object,
            required: false
        }
    },
    
    setup(props) {
        const store = useStore()

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'FundraisingAsideVue', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        const openPageOverlay = function(e) {

            store.commit('main/set_page_overlay_content_data', {
                qrImgUrlBase: props?.qrImgUrlBase,
                qrPrintPageLink: props?.qrPrintPageLink,
                qrPrintPageLinkTarget: props?.qrPrintPageLinkTarget,
                mobilePayCommentCode: props?.mobilePayCommentCode,
                mobilePayNumberCode: props?.mobilePayNumberCode,
                fundraisingCampaignId: props?.personalFundraisingGuid
            })
            
            store.dispatch('main/openPageOverlay', {
                overlayContent: "FundraisingQrCodeOverlay",
                returnTarget: e.currentTarget
            })
        }
        
        return {
            openPageOverlay,
            getLabel
        }
    }
}